module.exports = __webpack_public_path__ + "img/step2.0b4c0c50.png";